import { render, staticRenderFns } from "./ico_icon.vue?vue&type=template&id=04a13298&"
import script from "./ico_icon.vue?vue&type=script&lang=js&"
export * from "./ico_icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports